/**
 * Field Error Wrapper Component for validation messages
 */
import VueFormHelper from '../common/VueFormHelper'
import Notifier from '../common/Notifier'
import inputErrorWrapperComponent from './InputErrorWrapperComponent'

export default {
  data () {
    return {
      error: '',
      saveResponse: {
        globalErrors: [],
        fieldErrors: []
      }
    }
  },
  components: {
    'input-error-wrapper': inputErrorWrapperComponent
  },
  computed: {
    fieldError: function () {
      return VueFormHelper.processFieldErrors(this.saveResponse)
    }
  },
  methods: {
    onSuccess () {
      Notifier.success('Record saved successfully.')
    },
    onError (error) {
      Notifier.error(error)
    },
    clearErrors () {
      this.saveResponse.fieldErrors = []
      this.saveResponse.globalErrors = []
      Notifier.clear()
    }
  },
  watch: {
    saveResponse (response) {
      if (response.result === 'success' || response.result === 'approved') {
        this.onSuccess()
      } else if (response.result === 'error' && response.globalErrors) {
        for (let error of this.saveResponse.globalErrors) {
          this.onError(error)
        }
      }
    }
  }
}
